import React from "react";
import { decodeHtml } from "utils/formUtils";

const FormInfoText = ({ field }) => {
  const decoded = decodeHtml(field?.value || "");

  return <div dangerouslySetInnerHTML={{ __html: decoded }}></div>;
};

export default FormInfoText;
